<template>
  <div class="sr__like-list">
    <div
      v-for="(like, idx) in likes"
      :key="`${idx}`"
      class="d-flex align-items-center mb-3"
    >
      <!-- avatar -->
      <div class="d-flex align-items-start">
        <div class="sr__avater">
          <img :src="like.avatar_url">
        </div>
      </div>

      <div class="w-100">
        <div class="font-weight-bold d-flex align-items-center">
          <!-- name -->
          <span class="mr-2">{{ like.name }}</span>

          <!-- new like badge -->
          <div
            class = "sr__badge sr__badge--sq sr__badge--red"
            v-if  = "like.readed === false && isOwned(like)"
          >NEW</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'LikeList',
  props: {
    record: Object
  },
  data () {
    return {
      lineId: null,
      likes: []
    }
  },
  watch: {
    async start () {
    }
  },
  created () {
    console.log('LikeList created')
    this.lineId = this.$store.state.userId
    this.getLikes()
    // this.likes = [
    //   { name: 'John Doe', avatar_url: 'https://topcte.com/public_images/man_staff.jpg' },
    //   { name: 'Andy Wong', avatar_url: 'https://topcte.com/public_images/man_staff.jpg' }
    // ]
  },
  methods: {
    isOwned (like) {
      return like.line_id === this.lineId
    },
    apiUrl () {
      return `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/${this.record.id}/likes`
    },
    async getLikes () {
      this.likes = []

      try {
        const url = `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/${this.record.id}/likes`
        const resp = await this.$api.get(url)
        this.likes = resp.likes

        this.$emit('updateLikeCount', this.likes.length)
        return true
      } catch (e) {
        console.error(e)
        return false
      }
    }
  }
}
</script>
